import { Logger, LoggerService } from "@Shared/logger";
import { Screen } from "./screen.base";
import { OptionsModule } from "@Modules/options_module";
import { UIModule } from "@Modules/ui_module/ui.module";
import { Auth0LoginFormData } from "./models";
import { Auth0Service } from "@Modules/auth_module";
import { PipelineModule } from "@Modules/pipeline_module";
import { LoginStep } from "@Modules/pipeline_module/steps/auth/login.step";
import { Bus } from "@Modules/event_module";
import { APP_EVENTS } from "@Core";

export class LoginScreen extends Screen {
  private Logger: Logger = LoggerService.createLogger("LoginScreen");


  constructor() {
    super();
    this.Logger.trace("****  CTOR ****");

    this._html = UIModule.HTML.loginForm;
    this._screenOptions = OptionsModule.Options.ui.screens.login;

  }

  show(): void {
    super.show();
    const forgotPasswordLink = document.querySelector('#mng-auth-forgot-password') as HTMLAnchorElement;;
    if( forgotPasswordLink) {
      forgotPasswordLink.href = `https://${OptionsModule.Options.domain}/reset-password`;
    }
    this.Logger.trace("show called");
    this.handleForm();

    this._formSubmitHandler = this._form?.onSubmit<Auth0LoginFormData>(async (data) => {
      this.Logger.trace("Form submitted with data:", data);

      try {
        this._alert.hide();
        //NOTE: I think i should move login/reg screen and login/reg steps to use events so I don't have to have optional pipeline contexts. I should just register for an event in the screen 
        const showEntitlementCheckScreen = OptionsModule.Options.entitlement.showCheckScreenOnLogin;
        const resContext = await PipelineModule.startUserInitiatedAuthPipeline(new LoginStep(data.email, data.password),showEntitlementCheckScreen);
        this.Logger.trace("resContext", resContext);
        if(resContext.onLogin.result.success) {
          this.Logger.trace("Login successful");
          const authMode = OptionsModule.Options.auth.mode;
          if(authMode.type === "embedded" && authMode.options.reloadOnAuth){
            this.Logger.trace("Reloading page after login");
            location.reload();
          }else{
            this.Logger.trace("Not Reloading Page On Login, just firing onReady event");
            super.close();
            Bus.emit(APP_EVENTS.onReady, {auth: resContext.checkAuthStatus, entitlement: resContext?.checkEntitlements});
          }
          
          
        }
       
      } catch (error) {
        this.Logger.error("Login error", error);
      }finally {

      }
      

     

    });


  }



}